'use client';

import { createClient as createSupabaseClient } from '@supabase/supabase-js';

let supabaseBrowserClient: any = null;

export function createClient(): any {
  if (supabaseBrowserClient) return supabaseBrowserClient;

  const supabaseUrl = process.env.NEXT_PUBLIC_SUPABASE_URL;
  const supabaseAnonKey = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error(
      'Missing Supabase environment variables. Please set NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_ANON_KEY.'
    );
  }

  supabaseBrowserClient = createSupabaseClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      storageKey: 'proflow-auth-v2',
      persistSession: true,
      autoRefreshToken: false,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
  }) as any;

  return supabaseBrowserClient;
}
